/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * OAuth API
 * OAuth API for authentication and authorization
 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type { ExchangeAuthCode200, RefreshTokens200 } from "../types/oauth"

export const getExchangeAuthCodeResponseMock = (
	overrideResponse: Partial<Extract<ExchangeAuthCode200, object>> = {},
): ExchangeAuthCode200 => ({
	token: faker.string.alpha({ length: { min: 10, max: 20 } }),
	user: faker.string.alpha({ length: { min: 10, max: 20 } }),
	refreshToken: faker.string.alpha({ length: { min: 10, max: 20 } }),
	error: faker.helpers.arrayElement([
		faker.string.alpha({ length: { min: 10, max: 20 } }),
		null,
	]),
	...overrideResponse,
})

export const getRefreshTokensResponseMock = (
	overrideResponse: Partial<Extract<RefreshTokens200, object>> = {},
): RefreshTokens200 => ({
	access_token: faker.string.alpha({ length: { min: 10, max: 20 } }),
	refresh_token: faker.string.alpha({ length: { min: 10, max: 20 } }),
	...overrideResponse,
})

export const getExchangeAuthCodeMockHandler = (
	overrideResponse?:
		| ExchangeAuthCode200
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<ExchangeAuthCode200> | ExchangeAuthCode200),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/exchange",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getExchangeAuthCodeResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getRefreshTokensMockHandler = (
	overrideResponse?:
		| RefreshTokens200
		| ((
				info: Parameters<Parameters<typeof http.post>[1]>[0],
		  ) => Promise<RefreshTokens200> | RefreshTokens200),
	options?: RequestHandlerOptions,
) => {
	return http.post(
		"*/refresh",
		async (info: Parameters<Parameters<typeof http.post>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getRefreshTokensResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}
export const getOAuthAPIMock = () => [
	getExchangeAuthCodeMockHandler(),
	getRefreshTokensMockHandler(),
]
